/* Imperial Marketing & Co — site interactions */
(function () {
  'use strict';
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* Muted looping clips */
  function initVideos() {
    $$('video.im-video').forEach(function (v) {
      v.muted = true; v.loop = true; v.playsInline = true;
      var p = v.play && v.play();
      if (p && p.catch) p.catch(function () {});
    });
  }

  /* Accordions (FAQ folder tabs) */
  function initAccordions() {
    $$('[data-im-acc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-im-acc-group]');
        var open = btn.getAttribute('aria-expanded') !== 'true';
        if (group && open) {
          $$('[data-im-acc]', group).forEach(function (other) {
            if (other !== btn) setAcc(other, false);
          });
        }
        setAcc(btn, open);
      });
    });
  }
  function setAcc(btn, open) {
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (panel) panel.hidden = !open;
    var icon = btn.querySelector('.im-acc-icon');
    if (icon) icon.textContent = open ? '–' : '+';
  }

  /* Generic "pick one" groups: service disks + Imperial Method tabs */
  function initPickers(attr, panelAttr) {
    $$('[data-im-group="' + attr + '"]').forEach(function (group) {
      var buttons = $$('[data-im-pick]', group);
      var panels = $$('[' + panelAttr + ']', group);
      function show(i) {
        buttons.forEach(function (b, j) {
          var on = j === i;
          b.classList.toggle('on', on);
          if (b.hasAttribute('aria-pressed')) b.setAttribute('aria-pressed', on ? 'true' : 'false');
          if (b.getAttribute('role') === 'tab') b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p, j) { p.hidden = j !== i; });
        group.setAttribute('data-current', i);
      }
      buttons.forEach(function (b, i) { b.addEventListener('click', function () { show(i); }); });
      $$('[data-im-prev]', group).forEach(function (b) {
        b.addEventListener('click', function () { var c = +group.getAttribute('data-current') || 0; show((c - 1 + buttons.length) % buttons.length); });
      });
      $$('[data-im-next]', group).forEach(function (b) {
        b.addEventListener('click', function () { var c = +group.getAttribute('data-current') || 0; show((c + 1) % buttons.length); });
      });
      show(0);
    });
  }

  /* Day countdown to program doors opening (midnight US Eastern) */
  function initCountdowns() {
    $$('[data-im-countdown]').forEach(function (el) {
      var date = el.getAttribute('data-date') || '2026-11-23';
      var target = new Date(date + 'T00:00:00-05:00').getTime();
      var days = Math.ceil((target - Date.now()) / 86400000);
      var mode = el.getAttribute('data-im-countdown');
      if (mode === 'number') {
        el.textContent = Math.max(0, days);
      } else if (mode === 'label') {
        el.textContent = days === 1 ? 'day' : 'days';
      } else {
        el.textContent = days > 0 ? days + (days === 1 ? ' day' : ' days') : 'Open now';
      }
    });
  }

  /* 90-Day waitlist -> Klaviyo list (client subscriptions API) */
  function initWaitlist() {
    $$('form[data-im-klaviyo]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var key = form.getAttribute('data-key');
        var list = form.getAttribute('data-list');
        var msg = form.querySelector('.im-form-msg');
        var btn = form.querySelector('button[type="submit"]');
        var name = (form.elements['name'].value || '').trim();
        var email = (form.elements['email'].value || '').trim();
        var handle = (form.elements['handle'].value || '').trim();
        var stageEl = form.querySelector('input[name="stage"]:checked');
        var stage = stageEl ? stageEl.value : '';
        var parts = name.split(/\s+/);
        var first = parts.shift() || '';
        var last = parts.join(' ');
        if (!key || !list) { if (msg) msg.textContent = 'This form is not connected yet. Add your Klaviyo keys in Theme settings.'; return; }
        if (btn) { btn.disabled = true; btn.style.opacity = '.6'; }
        if (msg) msg.textContent = '';
        var body = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: '90-Day Strategy Program Waitlist',
              profile: { data: { type: 'profile', attributes: {
                email: email, first_name: first, last_name: last,
                properties: { 'Social Handle': handle, 'Business Stage': stage, 'Waitlist': '90-Day Strategy Program' }
              } } }
            },
            relationships: { list: { data: { type: 'list', id: list } } }
          }
        };
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
          body: JSON.stringify(body)
        }).then(function (res) {
          if (!res.ok && res.status !== 202) throw new Error('status ' + res.status);
          var wrap = form.closest('[data-im-waitlist]');
          if (wrap) {
            var f = wrap.querySelector('[data-im-waitlist-form]');
            var s = wrap.querySelector('[data-im-waitlist-success]');
            if (f) f.hidden = true;
            if (s) { s.hidden = false; s.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
          }
        }).catch(function () {
          if (msg) msg.textContent = 'Something went wrong. Please try again, or email admin@imperialmarketingco.com.';
          if (btn) { btn.disabled = false; btn.style.opacity = ''; }
        });
      });
    });
  }

  /* Opening scene: file cabinet -> logo folder (homepage, once per session) */
  function initIntro() {
    var intro = document.querySelector('[data-im-intro]');
    if (!intro) return;
    var stage = intro.querySelector('[data-im-stage]');
    var scene = intro.querySelector('[data-im-scene]');
    var timers = [];
    var forced = /[?&]intro=1/.test(location.search);
    var seen = false;
    try { seen = sessionStorage.getItem('im_intro_seen') === '1'; } catch (e) {}
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (seen && !forced) { intro.remove(); return; }

    function fit() {
      var s = Math.min(window.innerWidth / 900, window.innerHeight / 900, 1.15);
      stage.style.transform = 'scale(' + s + ')';
    }
    function setStage(n) { scene.className = scene.className.replace(/\bs[0-3]\b/g, '').trim() + ' s' + n; }
    function play(delay) {
      timers.forEach(clearTimeout);
      setStage(0);
      timers = [
        setTimeout(function () { setStage(1); }, delay),
        setTimeout(function () { setStage(2); }, delay + 1000),
        setTimeout(function () { setStage(3); }, delay + 1900)
      ];
    }
    function close() {
      try { sessionStorage.setItem('im_intro_seen', '1'); } catch (e) {}
      intro.classList.add('is-closing');
      document.body.classList.remove('im-intro-open');
      setTimeout(function () { intro.remove(); }, 650);
    }
    intro.hidden = false;
    document.body.classList.add('im-intro-open');
    fit();
    window.addEventListener('resize', fit);
    $$('[data-im-intro-open]', intro).forEach(function (b) { b.addEventListener('click', function () { play(0); }); });
    $$('[data-im-intro-replay]', intro).forEach(function (b) { b.addEventListener('click', function () { play(700); }); });
    $$('[data-im-intro-close]', intro).forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        close();
        var href = b.getAttribute('href') || '';
        var target = href.charAt(0) === '#' ? document.querySelector(href) : null;
        if (target && href !== '#MainContent') setTimeout(function () { target.scrollIntoView({ behavior: 'smooth' }); }, 350);
      });
    });
    $$('a[data-im-intro-link]', intro).forEach(function (a) {
      a.addEventListener('click', function () { try { sessionStorage.setItem('im_intro_seen', '1'); } catch (e) {} });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && document.body.contains(intro)) close(); });
    if (reduce) { setStage(3); } else { play(1100); }
  }

  function init() {
    initIntro();
    initVideos();
    initAccordions();
    initPickers('disks', 'data-im-screen');
    initPickers('method', 'data-im-step-panel');
    initCountdowns();
    initWaitlist();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
